import { render } from "./SolutionTemplateList.vue?vue&type=template&id=8ddf2d10&scoped=true"
import script from "./SolutionTemplateList.vue?vue&type=script&lang=js"
export * from "./SolutionTemplateList.vue?vue&type=script&lang=js"

import "./SolutionTemplateList.vue?vue&type=style&index=0&id=8ddf2d10&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ddf2d10"],['__file',"src/views/h5/ai/solution/SolutionTemplateList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8ddf2d10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8ddf2d10', __exports__)) {
    api.reload('8ddf2d10', __exports__)
  }
  
  module.hot.accept("./SolutionTemplateList.vue?vue&type=template&id=8ddf2d10&scoped=true", () => {
    api.rerender('8ddf2d10', render)
  })

}


export default __exports__